/*
* 割り当て済みのフィールドのロック
*/

export default class AssignLock {
  constructor() {
    // 割当済口数	
    this.$numberFields = document.querySelectorAll('[data-target="numberFields"]');
    // 追加割当口数
    this.$addedNumberFields = document.querySelectorAll('[data-target="addedNumberFields"]');
    this.$assignFlgs = document.querySelectorAll('[data-target="assignFlg"]');
  }

  attachEvent() {
    Array.prototype.forEach.call(this.$numberFields, (numberField, index) => {
      numberField.readOnly = true;
      if (parseInt(numberField.value) >= parseInt(numberField.dataset.applicationLimit)) {
        // 追加割当できないので除外する
        this.$addedNumberFields[index].readOnly = true;
        this.$assignFlgs[index].checked = true;
        this.$assignFlgs[index].disabled = true;
      }
    });
  }
}
